import styled, { keyframes } from 'styled-components';
import { Title, Text, Section as BaseSection } from '../../utils/theme';

export const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1vw;
  min-height: 35vw;
  height: auto;
  padding: 1.5vw;
  font-size: 1.25vw;

  @media (max-width: 600px) {   /*breakpoint for tablets and smaller devices */
    font-size: 3.6vw;
    align-items: center;
    flex-direction: column;
    
  }
`; 


export const Column = styled.div`
  flex: 1 1 calc(50% - 10px);  /*for 2 columns, minus gap*/
  overflow-y: auto;

  @media (max-width: 600px) {  /* breakpoint for tablets and smaller devices */
    flex: 1 1 100%; /* occupy full width on smaller screens */
    font-size: 3.6vw;
  }
`;

export const Dropdown = styled.div`
  border-top: 1px solid white;
  padding: 1vw;
`;

export const DropdownHeader = styled.div`
  cursor: pointer;
  padding: 0.5vw;
  display: flex;
  justify-content: space-between;
  overflow-y: hidden;
`;

export const DropdownContent = styled.div`
  padding: 0.1vw;
  max-height: 0;
  overflow: auto;
  transition: max-height 0.4s ease-in-out;
  overflow-y: hidden;

  &.open {
    max-height: 50vw; /* Adjust as needed */
  }
`;

export const ArrowDown = styled.div`
  width: 0; 
  height: 0; 
  border-left: 1vw solid transparent;
  border-right: 1vw solid transparent;
  border-top: 1vw solid white;

  @media (max-width: 600px) {
    border-left: 3vw solid transparent;
    border-right: 3vw solid transparent;
    border-top: 3vw solid white;
  }
`;

export const ArrowUp = styled.div`
  width: 0; 
  height: 0; 
  border-left: 1vw solid transparent;
  border-right: 1vw solid transparent;
  border-bottom: 1vw solid white;

  @media (max-width: 600px) {
    border-left: 3vw solid transparent;
    border-right: 3vw solid transparent;
    border-bottom: 3vw solid white;
  }
`;

export const Section = styled(BaseSection)`
  min-height: 0vh;
  position: relative;
  box-shadow: 0 0 5vw 5vw #090C1B inset;
  overflow: hidden;
`;

export const FaqTitle = styled(Title)`
  left: 0vw;
  width: 100vw;
  font-size: 2.5vw;
  margin: 0px;

  @media (max-width: 600px) {
    left: 10vw;
    width: 80vw;
    font-size: 6.25vw;
    text-align: left;
  }
`;

export const FaqText = styled(Text)`
  font-size: 1vw;
  text-align: center;
  width: 60vw;
  margin: 0px;

  @media (max-width: 600px) {
    left: 10vw;
    width: 80vw;
    font-size: 3.6vw;
    text-align: left;
  }
`;

const pulsing = keyframes`
  0%, 100% {
    transform: scale(1);
  } 
  50% {
    transform: scale(1.03);
  }
`;

export const FaqAurora = styled.img`
  z-index: -50;
  position: absolute;
  top: 0vw;
  left: 0vw;
  width: 100vw;
  min-height: 100%;

  animation: ${pulsing} 15s infinite ease-in-out;

  @media (max-width: 600px) {
    width: 300vw;
  }
`;
